import { TDeviceType } from '@cian/ui-kit';

import { getExtendedRegion } from 'shared/common/packages/Filters/shared/containers/filters/GeoContainer/helpers';
import { dealTypeFromJsonQuery, FDealType } from 'shared/common/packages/JsonQuery';
import { getAppliedModifiers } from 'shared/map-search/containers/DesktopFiltersMicrofrontend/utils';
import { GEO_CHANGE_ACTIONS } from 'shared/map-search/containers/FiltersContainer/constants';
import { trackApplyClick, trackPageView } from 'shared/map-search/containers/FiltersContainer/tracking';
import { selectExperiments } from 'shared/map-search/selectors/experiments';
import { selectParentRegionId } from 'shared/map-search/selectors/parentRegionId';
import { selectQueryString } from 'shared/map-search/selectors/queryString';
import { selectJsonQuery } from 'shared/map-search/selectors/results';
import { selectUser } from 'shared/map-search/selectors/user';
import { IFiltersUpdatedEventDetail } from 'shared/map-search/types/microfrontends';
import { TThunkAction } from 'shared/map-search/types/redux';
import { produceGeoChangeEvent } from 'shared/map-search/utils/events';
import { isHybridSearchRedirectNeeded } from 'shared/map-search/utils/isHybridSearchRedirectNeeded';
import { getDailyrentUrl } from 'shared/map-search/utils/url/getDailyRentUrl';

import { changeJsonQuery, fetchTags } from '../filters';
import { fetchNewbuildingPromoPins } from '../newbuildingPromoFeatures';
import { fetchClusters } from '../results';

interface IParams {
  isAwaitingGeoUpdate: React.MutableRefObject<boolean>;
  deviceType: TDeviceType;
  detail: IFiltersUpdatedEventDetail;
}

export function makeSearch({
  isAwaitingGeoUpdate,
  deviceType,
  detail: {
    jsonQuery,
    searchMeta: { fullUrl },
  },
}: IParams): TThunkAction<Promise<void>> {
  return async (dispatch, getState) => {
    const state = getState();
    const user = selectUser(state);
    const regionId = selectParentRegionId(state);
    const experiments = selectExperiments(state);
    const queryString = selectQueryString(state);
    const prevJsonQuery = selectJsonQuery(state);

    const { region } = jsonQuery;

    /**
     * @description
     * Сейчас посутка имеет отдельный мкс, поэтому делаем редирект на него
     */
    if (dealTypeFromJsonQuery(jsonQuery) === FDealType.RentDaily) {
      const dailyRentUrl = getDailyrentUrl(window.location.href);

      window.location.assign(dailyRentUrl);

      return;
    }

    if (fullUrl && isHybridSearchRedirectNeeded({ jsonQuery, experiments })) {
      window.location.assign(fullUrl);

      return;
    }

    dispatch(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      changeJsonQuery({ appliedModifiers: [] as any, prevJsonQuery, nextJsonQuery: jsonQuery }),
    );

    const appliedModifiers = getAppliedModifiers({ prevJsonQuery, nextJsonQuery: jsonQuery });

    if (appliedModifiers.some(modifier => GEO_CHANGE_ACTIONS.includes(modifier.action))) {
      isAwaitingGeoUpdate.current = true;

      trackPageView({
        jsonQuery,
        user,
        deviceType,
        regionId,
        experiments,
      });

      if (region) {
        produceGeoChangeEvent([{ action: 'setRegion', arguments: [getExtendedRegion(region.value[0])] }]);
      }
    }

    dispatch(fetchTags());
    dispatch(fetchClusters({ updateBounds: isAwaitingGeoUpdate.current, deviceType }));
    dispatch(fetchNewbuildingPromoPins());
    isAwaitingGeoUpdate.current = false;

    trackPageView({ jsonQuery, user, deviceType, regionId, experiments });
    trackApplyClick({ jsonQuery, queryString });
  };
}
